/**
 * Shared Directives Index
 * Central export for all shared directives
 */

export * from './highlight.directive';
export * from './truncate.directive';
